const lockName = (guid: string) => `slant:recording:${guid}`

// A lock survives pauses and background throttling, and the browser releases it when its tab dies.
export async function acquireRecordingLock(guid: string): Promise<() => Promise<void>> {
  if (!navigator.locks) throw new Error("This browser cannot safely record audio. Please use an up-to-date browser.")

  return new Promise((resolve, reject) => {
    const completed = navigator.locks
      .request(lockName(guid), { ifAvailable: true }, async (lock) => {
        if (!lock) {
          reject(new Error("This recording is active in another tab. Finish it there before recovering audio."))
          return
        }
        await new Promise<void>((release) =>
          resolve(async () => {
            release()
            await completed
          })
        )
      })
      .catch(reject)
  })
}

export async function recordingLocked(guid: string): Promise<boolean> {
  if (!navigator.locks) return true
  return navigator.locks.request(lockName(guid), { ifAvailable: true }, (lock) => !lock)
}
